export function normalizeEmailValue(value) {
  if (value == null || value === "") return value;
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  return trimmed === "" ? trimmed : trimmed.toLowerCase();
}
